import React, { useEffect, useState } from "react";
import axios from "axios";

// servicios
import { detalleSolicitudTodos } from "../Services/Rest";
import Swal from "sweetalert2";

function AsignarDirector() {
  const [solicitud, setSolicitud] = useState([]);
  const [usuario, setUsuario] = useState([]);

  const [postNombre, setPostNombre] = useState("");
  const [postEquipo, setPostEquipo] = useState("");
  const [postSolicitud, setPostSolicitud] = useState("");

  // 🔹 Obtener solicitudes
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: detalleSolicitudTodos,
    })
      .then((response) => {
        setSolicitud(response.data);
      })
      .catch((error) => {
        console.error("Error solicitudes:", error);
      });
  }, []);

  // 🔹 Obtener usuarios
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/Api/ObtenerUsuarioPorTipoUsuario?Tipo_Usuario=6",
    })
      .then((response) => {
        setUsuario(response.data);
      })
      .catch((error) => {
        console.error("Error usuarios:", error);
      });
  }, []);

  const postData = (e) => {
    e.preventDefault();

    if (!postSolicitud || !postEquipo) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Debe seleccionar solicitud y usuario",
      });
      return;
    }

    const dataToSend = {
      nombre: postNombre || "DIRECTOR",
      evaluadorId: Number(postEquipo),
      idRolSolicitud: "3",
      solicitudId: Number(postSolicitud),
    };

    console.log("DATA A ENVIAR:", dataToSend);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/AsignaSolicitudDirector",
      data: dataToSend,
    })
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: response.data,
          confirmButtonColor: "#3085d6",
        });
      })
      .catch((error) => {
        console.error("ERROR:", error);

        let mensaje = "Error al enviar la información";

        if (error.response) {
          mensaje = error.response.data;
        } else if (error.request) {
          mensaje = "No hubo respuesta del servidor";
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: mensaje,
          confirmButtonColor: "#d33",
        });
      });
  };

  // 🔹 Filtro
  const filtro1 = solicitud.filter((e) => e.estado == "Informe en revisión");

  return (
    <div className="test">
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Asignar Director de Acreditación
                </h6>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <form className="user">
                    {/* 🔹 Select solicitud */}
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostSolicitud(e.target.value)}
                        >
                          <option value="">Solicitudes para asignar</option>
                          {filtro1.map((item) => (
                            <option key={item.solicitud} value={item.solicitud}>
                              {item.nombreInstitucion +
                                " " +
                                item.tipoSolicitud +
                                " #" +
                                item.solicitud}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* 🔹 Select usuario */}
                    <div className="form-group">
                      <select
                        className="btn btn-secondary btn-user btn-block"
                        onChange={(e) => {
                          const selected = usuario.find(
                            (u) => u.id == e.target.value,
                          );
                          setPostEquipo(e.target.value);
                          setPostNombre(selected?.nombre || "");
                        }}
                      >
                        <option value="">Seleccione el usuario</option>
                        {usuario.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nombre}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* 🔹 Botón */}
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={postData}
                    >
                      Guardar
                    </button>

                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AsignarDirector;
